export default "__VITE_ASSET__FXx2O0V6__"